module.exports = __webpack_public_path__ + "img/flip-icon.0d62b8f8.png";